export interface GetJnjPaymentListResponse {
    isSuccess: boolean
    message: any
    data: GetJnjPaymentListResponseData
}

export interface GetJnjPaymentListResponseData {
    items: GetJnjPaymentListResponseItem[]
    totalRecordCount: number
}

export const initialGetJnjPaymentListResponseData: GetJnjPaymentListResponseData = {
    items: [],
    totalRecordCount: 0
}

/** J&J portalındaki "Search Payment Information" sonucunun bir satırı (JnjPaymentController.MapEntityToResponse). */
export interface GetJnjPaymentListResponseItem {
    jnjPaymentRecordId: string
    searchedPoNo: string
    poNumber?: string
    invoiceNumber?: string
    invoiceDateStr?: string
    invoiceDueDateStr?: string
    dynamicDiscount?: string
    totalInvoiceAmount?: number
    taxAmount?: number
    invoicePaidAmount?: number
    totalPaymentAmount?: number
    currency?: string
    invoiceStatus?: string
    invoiceStatusDetail?: string
    /** Türkçe durum (ekranda görünen, filtrelenen). */
    /** Mukerrer red (15.10.2026): "Evet" = ayni faturanin Odendi kaydi var (panoda Reddedildi sayilmaz). */
    mukerrerRed?: string | null
    invoiceStatusTr?: string
    invoiceStatusDetailTr?: string
    checkEftTraceNo?: string
    paymentDateStr?: string
    checkCashedDateStr?: string
    supplierNumber?: string
    invoiceLogId: string
    jnjCompanyCode?: string
    jnjCompanyName?: string
    itemText?: string
    clearingDocument?: string
    fiDocumentNumber?: string
    firstSeenDateStr?: string
    lastSeenDateStr?: string
    previousStatus?: string
    statusChangedDateStr?: string
    /** Ekranda satır seçimi (Excel "Seçilenler"). */
    isSelected?: boolean
}
